/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BeneficialOwnerPEPUpdate {
  readonly id: string;
  readonly status: string;
  readonly added_by_id: string | null;
  readonly comment: string;
}
